import { render, staticRenderFns } from "./FormPermissions.vue?vue&type=template&id=1a7f0aec&"
import script from "./FormPermissions.vue?vue&type=script&lang=js&"
export * from "./FormPermissions.vue?vue&type=script&lang=js&"
import style0 from "./FormPermissions.vue?vue&type=style&index=0&id=1a7f0aec&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports